import React from "react";
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { withRouter } from "react-router";
import "../index.css";
// import Layout from "./Layout/Layout";


import Home from "../pages/Home/Home";
import PracticeAreas from "../pages/PracticeAreas/PracticeAreas";
import Sectors from "../pages/Sectors/Sectors";
import SectorsDetails from "../pages/SectorsDetails/SectorsDetails";
import SectorsAutomotiveDetails from "../pages/SectorsAutomotiveDetails/SectorsAutomotiveDetails";
import Expertise from "../pages/Expertise/Expertise";
import AshishAmbasta from "../pages/AshishAmbasta/AshishAmbasta";
import AshokGupta from "../pages/AshokGupta/AshokGupta";
import ContactUs from "../pages/ContactUs/ContactUs";


export default function App() {
  return (
    <BrowserRouter>
      <Switch>
        {/* <PublicRoute exact path="/" render={() => <Redirect to="/leadership" />} /> */}
        <PublicRoute exact path="/" component={withRouter(Home)} />
        <PublicRoute exact path="/home" component={withRouter(Home)} />
        <PublicRoute exact path="/practiceareas" component={withRouter(PracticeAreas)} />
        <PublicRoute exact path="/sectors" component={withRouter(Sectors)} />
        <PublicRoute exact path="/sectorsdetails" component={withRouter(SectorsDetails)} />
        <PublicRoute exact path="/sectorsautomotivedetails" component={withRouter(SectorsAutomotiveDetails)} />
        <PublicRoute exact path="/expertise" component={withRouter(Expertise)} />
        <PublicRoute exact path="/expertise/ashish-ambasta" component={withRouter(AshishAmbasta)} />
        <PublicRoute exact path="/expertise/ashok-gupta" component={withRouter(AshokGupta)} />
        <PublicRoute exact path="/contact-us" component={withRouter(ContactUs)} />
      </Switch>
    </BrowserRouter>
  );

  function PublicRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={(props) =>
        (
          React.createElement(component, props)
        )
        }
      />
    );
  }
}